import { useFormikContext } from 'formik';

import { Label } from '@src/design-system/label';
import { Textfield } from '@src/shared/fields/text-field';
import { RadioGroup, RadioGroupItem } from '@src/design-system/radio';
import { SavedViewsSelect } from '@src/shared/features/views/components/saved-views-select';
import type { TAudienceGroup, TCreateReminderFormValues } from '../schema';
import { ProgramSelect } from './program-select';

export function BulkAudienceSection() {
  const { values, setFieldValue } =
    useFormikContext<TCreateReminderFormValues>();

  const setAudience = (next: TAudienceGroup) => {
    setFieldValue('audienceGroup', next);
    setFieldValue('program', null);
    setFieldValue('view', undefined);
  };

  return (
    <section className='rounded-xl border border-[#E8E7F0] bg-white p-4'>
      <p className='mb-4 text-sm font-semibold text-gray-500'>
        1. Audience Details
      </p>

      <div className='flex flex-col gap-4'>
        <Textfield
          label='Reminder name'
          name='name'
          placeholder='Enter Reminder Name'
        />

        <div>
          <Label className='mb-2 inline-block'>Audience From</Label>
          <RadioGroup
            className='flex flex-wrap gap-4'
            value={values.audienceGroup}
            onValueChange={(v) => setAudience(v as TAudienceGroup)}
          >
            <label className='flex cursor-pointer items-center gap-2 text-sm'>
              <RadioGroupItem value='program' />
              Program
            </label>
            <label className='flex cursor-pointer items-center gap-2 text-sm'>
              <RadioGroupItem value='leads' />
              Leads
            </label>
          </RadioGroup>
        </div>

        {values.audienceGroup === 'program' ? <ProgramSelect /> : null}

        <SavedViewsSelect
          key={values.audienceGroup}
          entity_type={
            values.audienceGroup === 'leads' ? 'LEAD' : 'APPLICATION'
          }
          appliedAll={{
            APPLICATION: 'All Participants',
          }}
        />
      </div>
    </section>
  );
}
